import React, { useState } from 'react'
import { Tab, Typography } from '@material-ui/core'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check-copy-10.svg'
import { ReactComponent as CloseIcon } from 'assets/icons/close-red.svg'
import TextField from '@material-ui/core/TextField'
import styles from 'components/Shared/Tabs/StyledTab/StyledTab.module.css'
import { WarningDialog } from 'components/Shared/Dialogs'
import classNames from 'classnames'

export default function StyledTab ({
  className,
  label,
  id,
  showDelete,
  showEdit,
  alwaysShowIcons,
  onClick,
  onRemove,
  onNameChange
}) {
  const [isInEditMode, setIsInEditMode] = useState(false)
  const [editNameValue, setEditNameValue] = useState(label)
  const [showCloseTabDialog, setShowCloseTabDialog] = useState(false)

  const handleCloseTabDialogClose = (removeApproved) => {
    if (removeApproved) {
      onRemove(id)
    }
    setShowCloseTabDialog(false)
  }

  const editTextField =
    <TextField
      onChange={(event) => setEditNameValue(event.target.value)}
      value={editNameValue}
      className={styles.textField}
      InputProps={{
        endAdornment: (
          <div className={styles.iconsWrapper}>
            <CheckIcon
              className={styles.checkIcon}
              onClick={(event) => {
                onNameChange(id, editNameValue)
                setIsInEditMode(false)
                event.stopPropagation()
              }}/>
            <CloseIcon
              className={styles.closeIcon}
              onClick={(event) => {
                setIsInEditMode(false)
                event.stopPropagation()
              }}/>
          </div>
        )
      }}
    />

  const showTab =
    <>
      <WarningDialog open={showCloseTabDialog}
                     onClose={handleCloseTabDialogClose}
                     title={'table.tabs.close.title'}
                     content={'table.tabs.close.content'}/>
      <Typography className={styles.tabWrapper}>
      <span className={styles.tabName}>
        {label}
      </span>
        {showEdit && <EditIcon className={styles.editIcon}
                             onClick={(event) => {
                               setIsInEditMode(true)
                               event.stopPropagation()
                             }}/>}
      {showDelete && <TrashIcon className={styles.removeIcon}
                                onClick={(event) => {
                                  setShowCloseTabDialog(true)
                                  event.stopPropagation()
                                }}/>}
      </Typography>
    </>

  return (
    <Tab
      className={classNames(className, alwaysShowIcons ? '': styles.tab)}
      onClick={onClick}
      label={isInEditMode ? editTextField : showTab}
    />
  )
}
